const gameAreaBoxClasses =
  "w-full self-stretch aspect-[9/16] md:aspect-[1.78] max-h-[80svh] min-h-[400px]";

export default gameAreaBoxClasses;
